import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarHeader, SidebarGroupContent, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '~/components/shadcn/sidebar';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '~/components/shadcn/collapsible';
import { menuMain } from '~/constants/menuConstants';
import { useCollapsibleItems } from '~/hooks/useCollapsibleItems';
import { memo, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { toPluralEntity, isKnownLinePlanEntityId } from '~/utils/linePlanEntity';
import { lowerCase } from 'lodash';
const MenuItemContent = ({ item }) => (_jsxs(_Fragment, { children: [item.icon && _jsx(item.icon, { className: "mr-2 h-4 w-4", "aria-hidden": "true" }), _jsx("span", { children: item.label })] }));
const MenuItemWrapper = memo(({ item, isSubmenu = false }) => {
    const linkClasses = () => {
        return [
            'flex items-center',
            isSubmenu ? 'ml-2 text-sm' : '',
            item.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        ]
            .filter(Boolean)
            .join(' ');
    };
    return (_jsx(SidebarMenuItem, { children: _jsx(SidebarMenuButton, { asChild: true, children: item.sub ? (_jsx("a", { "aria-haspopup": "true", role: "button", tabIndex: 0, className: linkClasses(), "aria-expanded": false, children: _jsx(MenuItemContent, { item: item }) })) : (_jsx(Link, { to: item.url, className: linkClasses(), "aria-disabled": item.disabled, tabIndex: item.disabled ? -1 : 0, children: _jsx(MenuItemContent, { item: item }) })) }) }));
});
MenuItemWrapper.displayName = 'Pulse Menu';
function AppSidebar() {
    const { openItems, toggleItem } = useCollapsibleItems();
    const location = useLocation();
    const currentViewType = useMemo(() => {
        const match = location.pathname.match(/\/view\/(grid|card)(?:$|\/)/);
        return match?.[1] || 'card';
    }, [location.pathname]);
    const entityAwareMenu = useMemo(() => {
        return menuMain.map((item) => {
            const linePlanEntityLower = lowerCase(item.id || '');
            if (!isKnownLinePlanEntityId(linePlanEntityLower)) {
                return item;
            }
            if (item.id === 'Products') {
                return item;
            }
            const linePlanEntity = toPluralEntity(linePlanEntityLower);
            return { ...item, url: `/${linePlanEntity}/view/${currentViewType}` };
        });
    }, [currentViewType]);
    return (_jsxs(Sidebar, { children: [_jsx(SidebarHeader, { className: "pt-20" }), _jsx(SidebarContent, { children: _jsx(SidebarGroup, { children: _jsx(SidebarGroupContent, { className: "pl-5", children: _jsx(SidebarMenu, { role: "navigation", "aria-label": "Main Navigation", children: entityAwareMenu.map((item) => item.sub ? (_jsxs(Collapsible, { open: openItems[item.label || ''], onOpenChange: () => toggleItem(item.label || ''), children: [_jsx(CollapsibleTrigger, { asChild: true, children: _jsx("div", { children: _jsx(MenuItemWrapper, { item: item }) }) }), _jsx(CollapsibleContent, { className: "pl-7", children: _jsx("div", { role: "group", "aria-label": `${item.label} submenu`, children: item.sub.map((subitem) => (_jsx(MenuItemWrapper, { item: subitem, isSubmenu: true }, subitem.label))) }) })] }, item.label)) : (_jsx(MenuItemWrapper, { item: item }, item.label))) }) }) }) }), _jsx(SidebarFooter, {})] }));
}
export default AppSidebar;
